<template>
  <div class="error-page">
    <div class="content-con">
      <img class="img-con" :src="src" :alt="code" />
      <div class="text-con">
        <h1>{{ code }}</h1>
        <h5>{{ desc }}</h5>
        <slot name="btn_back"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'error_content',
  props: {
    code: String,
    desc: String,
    src: {
      type: String,
      default: ''
    },
    goback: {
      type: String,
      default: ''
    }
  },
  methods: {
    reset() {
      window.location.reload()
    },
    backHandler() {
      this.$router.push({
        name: this.goback,
        query: {
          date_time: JSON.parse(localStorage.shopRankCache).filterParams.date_time
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.error-page {
  width: 1200px;
  height: 100%;
  margin: auto;
  margin-top: 100px;
  .content-con {
    display: flex;
    height: 480px;
    flex-direction: column;
    align-items: center;
  }
  .img-con {
    max-width: 40%;
  }
  .text-con {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    h1 {
      font-size: 24px;
      font-weight: 600;
      color: #434e59;
      line-height: 56px;
      margin: 0;
    }
    h5 {
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.45);
      line-height: 37px;
    }
  }
}
</style>
